import api from "../services/api";

export const createAdminUser = async (data) => {
    try {
        const response = await api.post(`/admin/register`, data);
        return response;
    } catch (error) {
        console.error('Erro ao criar conta:', error?.response?.data);
        throw error;
    }
}

export const getAllAdminUsers = async () => {
    try {
        const response = await api.get(`/admin/users`);
        return response;
    } catch (error) {
        console.error('Erro ao exibir usuários:', error?.response?.data);
        throw error;
    }
}

export const adminUserEdit = async (id, data) => {
    try {
        const response = await api.patch(`/admin/${id}/`, data);
        console.log(response?.data);
        return response;
    } catch (error) {
        console.error('Erro ao editar usuário:', error?.response?.data);
        throw error;
    }
}

export const updateSubscription = async (id, data) => {
    try {
        const response = await api.put(`/admin/subscription/${id}`, data);
        console.log(response?.data);
        return response;
    } catch (error) {
        console.error('Erro ao atualizar subscrição:', error?.response?.data);
        throw error;
    }
}

export const getAdminSelected = async (id) => {
    try {
        const response = await api.get(`/admin/${id}`);
        return response;
    } catch (error) {
        console.error('Erro ao obter usuário:', error?.response?.data);
        throw error;
    }
}

export const deleteAdminUser = async (id) => {
    try {
        const response = await api.delete(`/admin/delete/${id}`);
        return response;
    } catch (error) {
        console.error('Erro ao deletar usuário:', error?.response?.data);
        throw error;
    }
}

// Exclusão de usuária a partir do painel — restrita no backend pra requireUserDeletePermission
// (só gestaonovaeradigital@gmail.com / alexandresaintss@gmail.com), diferente do delete
// comum de UserBusiness (que é self-delete, exige senha do próprio dono).
export const adminDeleteUser = async (id) => {
    try {
        const response = await api.delete(`/admin/users/${id}`);
        return response;
    } catch (error) {
        console.error('Erro ao excluir usuário:', error?.response?.data);
        throw error;
    }
}

export const updatePlanOverride = async (id, planOverride, planOverrideExpiresAt) => {
    try {
        const response = await api.put(`/admin/plan-override/${id}`, { planOverride, planOverrideExpiresAt });
        return response;
    } catch (error) {
        console.error('Erro ao atualizar planOverride:', error?.response?.data);
        throw error;
    }
}

export const updateEnterpriseConfig = async (id, data) => {
    try {
        const response = await api.put(`/admin/enterprise-config/${id}`, data);
        return response;
    } catch (error) {
        console.error('Erro ao atualizar configuração enterprise:', error?.response?.data);
        throw error;
    }
}

export const getAdmins = async () => {
    try {
        const response = await api.get(`/admin/admins`);
        return response;
    } catch (error) {
        console.error('Erro ao listar admins:', error?.response?.data);
        throw error;
    }
}

export const createAdminAccount = async (data) => {
    try {
        const response = await api.post(`/admin/admins`, data);
        return response;
    } catch (error) {
        console.error('Erro ao criar admin:', error?.response?.data);
        throw error;
    }
}

export const updateAdminAccount = async (id, data) => {
    try {
        const response = await api.put(`/admin/admins/${id}`, data);
        return response;
    } catch (error) {
        console.error('Erro ao atualizar admin:', error?.response?.data);
        throw error;
    }
}

export const deleteAdminAccount = async (id) => {
    try {
        const response = await api.delete(`/admin/admins/${id}`);
        return response;
    } catch (error) {
        console.error('Erro ao deletar admin:', error?.response?.data);
        throw error;
    }
}

export const getAdminReports = async (params = {}) => {
    try {
        const query = new URLSearchParams(params).toString();
        const response = await api.get(`/admin/reports${query ? '?' + query : ''}`);
        return response;
    } catch (error) {
        console.error('Erro ao buscar relatórios:', error?.response?.data);
        throw error;
    }
}